import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound({ message = 'The page you are looking for does not exist.' }) {
  return (
    <div className="page page--narrow center">
      <p className="eyebrow">Not found</p>
      <h1 className="page__title">Nothing here</h1>
      <p className="muted">{message}</p>
      <Link to="/" className="btn">Back to home</Link>
    </div>
  );
}
